<template>
	<div>
		<div class='sidebar-title-container'>
			<span class='sidebar-header' @click='isOpenMyDelas=!isOpenMyDelas'>
				<span class='sidebar-title'>
					<icon icon-name='arrow-collapse' class='arrow-collapse' />
					My deals
				</span>
				<span class='see_all'  @click='showMyDealsHandle'>See all</span>
			</span>
		</div>
		<collapse-transition>
			<div v-show='isOpenMyDelas'>
				<ListOfSidebarDeals
					:listOfDeals='listOfMyDeals'
					class='mo-mt'
				/>
			</div>
		</collapse-transition>
		<div class='sidebar-title-container'>
			<span class='sidebar-header' @click='isOpenLatestDelas=!isOpenLatestDelas'>
				<span class='sidebar-title'>
					<icon icon-name='arrow-collapse' class='arrow-collapse' />
					Latest public deals
				</span>
			</span>
		</div>
		<collapse-transition>
			<div v-show='isOpenLatestDelas'>
				<ListOfSidebarDeals
					class='title-sm'
					v-if='profile.major_market.id && listOfLatestDealsMajorMarket.length'
					@select='showAllPublicDeals(profile.major_market.id)'
					:listOfDeals='listOfLatestDealsMajorMarket'
					:label='profile.major_market.name'
					:count='MajorMarketCount'
					:link='`/markets/${profile.major_market.id}/?tab=Public%20deals`'
				/>
				<ListOfSidebarDeals
					class='title-sm'
					v-if='profile.sub_market.id && listOfLatestDealsSubMarket.length'
					@select='showAllPublicDeals(profile.sub_market.id)'
					:listOfDeals='listOfLatestDealsSubMarket'
					:label='profile.sub_market.name'
					:count='SubMarketCount'
					:link='`/markets/${profile.sub_market.id}/?tab=Public%20deals`'
				/>
			</div>
		</collapse-transition>
		<div class='sidebar-title-container mb-10'>
			<span class='sidebar-header' @click='isOpenAgents=!isOpenAgents'>
				<span class='sidebar-title'>
					<icon icon-name='arrow-collapse' class='arrow-collapse' />
					Certified agents
				</span>
			</span>
		</div>
		<collapse-transition>
			<div v-show='isOpenAgents'>
				<Agents v-if='profile.major_market && profile.major_market.id' :market='profile.major_market.id' :label='profile.major_market.name' />
				<Agents v-if='profile.sub_market && profile.sub_market.id' :market='profile.sub_market.id' :label='profile.sub_market.name'  />
			</div>
		</collapse-transition>
		<div class='sidebar-title-container mb-10'>
			<span class='sidebar-header' @click='isOpenListedAgents=!isOpenListedAgents'>
				<span class='sidebar-title'>
					<icon icon-name='arrow-collapse' class='arrow-collapse' />
					Market Meetup Leaders
				</span>
			</span>
		</div>
		<collapse-transition>
			<div v-show='isOpenListedAgents'>
				<Agents v-if='profile.major_market && profile.major_market.id'
					:market='profile.major_market.id'
					:label='profile.major_market.name'
					type='listed_agent'
				/>
				<Agents v-if='profile.sub_market && profile.sub_market.id'
					:market='profile.sub_market.id'
					:label='profile.sub_market.name'
					type='listed_agent'
				/>
			</div>
		</collapse-transition>
	</div>
</template>
<script>
import api from '__jsVueApi';
import ListOfSidebarDeals from '__jsVueSections/ListOfSidebarDeals/ListOfSidebarDeals.vue';
import Agents from './components/Agents/Agents.vue';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
import icon from '__jsVueUI/icon.vue';
export default {
	name:       'Sidebar',
	components: {
		ListOfSidebarDeals,
		Agents,
		CollapseTransition,
		icon
	},
	data() {
		return {
			listOfMyDeals:                [],
			listOfLatestDealsMajorMarket: [],
			MajorMarketCount:             0,
			listOfLatestDealsSubMarket:   [],
			SubMarketCount:               0,

			isOpenMyDelas:      false,
			isOpenLatestDelas:  false,
			isOpenAgents:       false,
			isOpenListedAgents:      false,
		};
	},
	mounted() {
		this.loadMyDeals();
		this.loadMyDealsMajorMarket();
		this.loadLatestDealsSubMarket();
	},
	methods: {
		showMyDealsHandle() {
			window.location.href = `/deals/past/`;
		},
		showAllPublicDeals(merket) {
			window.location.href = `/markets/${merket}/?tab=Public%20deals`;
		},
		async loadMyDeals() {
			await axios.get(api.deals.my).then((response) => {
				this.listOfMyDeals = response.data;
			});
		},
		async loadMyDealsMajorMarket() {
			let pageSize = 2;
			if (this.profile.major_market && this.profile.major_market.id) {
				await axios.get(api.deals.latest, {
					params: {
						market:    this.profile.major_market.id,
						page_size: pageSize,
						page:      1,
					}
				}).then((response) => {
					this.listOfLatestDealsMajorMarket = response.data.results;
					this.MajorMarketCount = response.data.count;
				});
			}
		},
		async loadLatestDealsSubMarket() {
			let pageSize = 2;
			if (this.profile.sub_market && this.profile.sub_market.id) {
				await axios.get(api.deals.latest, {
					params: {
						market:    this.profile.sub_market.id,
						page_size: pageSize,
						page:      1,
					}
				}).then((response) => {
					this.listOfLatestDealsSubMarket = response.data.results;
					this.SubMarketCount = response.data.count;
				});
			}
		},
	},
	computed: {
		profile() {
			return this.$store.state.profile.profile;
		},
	},
};
</script>
